module.exports = __webpack_public_path__ + "img/roodie-checks.4489b679.svg";